var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashCan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    stroke: "#EB635F",
    strokeWidth: 1.5,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.13281 4.00006H2.32541H11.8661",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6724 3.99998V13.3333C10.6724 13.6869 10.5467 14.0261 10.3231 14.2761C10.0994 14.5262 9.79607 14.6666 9.47978 14.6666H3.51681C3.20052 14.6666 2.89718 14.5262 2.67352 14.2761C2.44987 14.0261 2.32422 13.6869 2.32422 13.3333V3.99998M4.11311 3.99998V2.66665C4.11311 2.31302 4.23876 1.97389 4.46241 1.72384C4.68606 1.47379 4.98941 1.33331 5.3057 1.33331H7.69089C8.00718 1.33331 8.31052 1.47379 8.53418 1.72384C8.75783 1.97389 8.88348 2.31302 8.88348 2.66665V3.99998",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashCan);
export default __webpack_public_path__ + "static/media/trash-can.3a455b510be37103ae2a2f0f4d1f4290.svg";
export { ForwardRef as ReactComponent };